import { RegisterForm } from './RegisterForm'
import { SubmitButton } from './SubmitButton'
import { ErrorDisplay } from './ErrorDisplay'
import type React from 'react'

export type Components = {
  form?: React.ElementType
  button?: React.ElementType
  errorDisplay?: React.ElementType
}

export const components = {
  form: RegisterForm,
  button: SubmitButton,
  errorDisplay: ErrorDisplay,
}
